var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgListIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 4,
    fill: "#F9FAFB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 14.0001L11.5 14.0001M21.5 9.00008L11.5 9.00008M21.5 19.0001L11.5 19.0001M8.16667 14.0001C8.16667 14.4603 7.79357 14.8334 7.33333 14.8334C6.8731 14.8334 6.5 14.4603 6.5 14.0001C6.5 13.5398 6.8731 13.1667 7.33333 13.1667C7.79357 13.1667 8.16667 13.5398 8.16667 14.0001ZM8.16667 9.00008C8.16667 9.46032 7.79357 9.83341 7.33333 9.83341C6.8731 9.83341 6.5 9.46032 6.5 9.00008C6.5 8.53984 6.8731 8.16675 7.33333 8.16675C7.79357 8.16675 8.16667 8.53984 8.16667 9.00008ZM8.16667 19.0001C8.16667 19.4603 7.79357 19.8334 7.33333 19.8334C6.8731 19.8334 6.5 19.4603 6.5 19.0001C6.5 18.5398 6.8731 18.1667 7.33333 18.1667C7.79357 18.1667 8.16667 18.5398 8.16667 19.0001Z",
    stroke: "#98A2B3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListIcon);
export default __webpack_public_path__ + "static/media/list_icon.1dd9dcf06937e0cf08c49e9c5ad87012.svg";
export { ForwardRef as ReactComponent };